import { render, staticRenderFns } from "./ServergpsList.vue?vue&type=template&id=07d08743"
import script from "./ServergpsList.vue?vue&type=script&lang=js"
export * from "./ServergpsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports